import React from 'react'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faChartLine,
    faChevronCircleUp,
    faChevronCircleDown,
    faCogs,
} from '@fortawesome/pro-duotone-svg-icons'

const AdminMenuItems = [
    {
        id: 'generic',
        label: 'Generic',
        path: '/environment/edit',
        permission: 'kedo.env',
        icon: null,
    },
    {
        id: 'datastructures',
        label: 'Datastructures',
        path: '/datastructure',
        permission: 'kedo.datastructure',
        icon: null,
    },
    {
        id: 'erd',
        label: 'ERD',
        path: '/erd',
        permission: 'kedo.erd',
        icon: null,
    },
    {
        id: 'roles',
        label: 'Roles',
        path: '/roles',
        permission: 'kedo.role.index',
        icon: null,
    },
    {
        id: 'permissions',
        label: 'Permissions',
        path: '/permissions',
        permission: 'kedo.defdossierpermission',
        icon: null,
    },
    {
        id: 'logs',
        label: 'Logs',
        path: '/logs',
        permission: 'kedo.logs',
        icon: null,
    },
    {
        id: 'useractivity',
        label: 'User activity',
        path: '/useractivity',
        permission: 'kedo.useractivity',
        icon: null,
    },
    {
        id: 'files',
        label: 'Files',
        path: '/files',
        permission: 'kedo.file.index',
        icon: null,
    },
    {
        id: 'users',
        label: 'Users',
        path: '/user',
        permission: 'kedo.user.index',
        icon: null,
    },
    {
        id: 'languages',
        label: 'Languages',
        path: '/languages',
        permission: 'kedo.locale.index',
        icon: null,
    },
    {
        id: 'blocks',
        label: 'Blocks',
        path: '/blocks',
        permission: 'kedo.mypageblocks.index',
        icon: null,
    },
    {
        id: 'modules',
        label: 'Modules',
        path: '/modules',
        permission: 'kedo.module.index',
        icon: null,
    },
    {
        id: 'events',
        label: 'Events',
        path: '/events',
        permission: 'kedo.event.index',
        icon: null,
    },
    {
        id: 'kedocx',
        label: 'Kedocx',
        path: '/wordkedocx',
        permission: 'kedo.kedocx.index',
        icon: null,
    },
    {
        id: 'querybuilder',
        label: 'Querybuilder',
        path: '/querybuilder',
        permission: 'kedo.querybuilder',
        icon: null,
    },
    {
        id: 'webhooks',
        label: 'Webhooks',
        path: '/webhooks',
        permission: 'kedo.webhooks.index',
        icon: null,
    },
]

class AdminMainMenu extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            displayAdminSettings: false,
        }

        this.handleAdminSettings = this.handleAdminSettings.bind(this)
        this.hasPermissions = this.hasPermissions.bind(this)
    }

    handleAdminSettings() {
        this.setState((state) => ({
            displayAdminSettings: !state.displayAdminSettings,
        }))
    }

    hasPermissions() {
        if (this.props.kedo.isAdminOrEnvironmentAdmin()) {
            return true
        }

        const credentials = this.props.kedo.env().environment.credentials || []
        console.log(credentials)

        return AdminMenuItems.some((adminPermission) =>
            credentials.some((cred) =>
                cred.startsWith(adminPermission.permission)
            )
        )
    }

    render() {
        const kedo = this.props.kedo

        return (
            <nav className="dropdown MainMenu" aria-label="Admin Navigation">
                <ul style={{ background: 'none', borderTop: 'none' }}>
                    <li
                        className={'menu-item avLinkStyle'}
                        onClick={this.props.close}
                    >
                        <NavLink
                            activeClassName="selectedLink"
                            className={'menuHeadItem dashboard navLinkStyle'}
                            key={'dashboard'}
                            exact
                            to={`/`}
                        >
                            <FontAwesomeIcon icon={faChartLine} /> &nbsp;{' '}
                            {kedo.t('Dashboard')}
                        </NavLink>
                    </li>
                </ul>
                {this.hasPermissions() ? (
                    <div
                        onClick={this.handleAdminSettings}
                        className={'menuHeadItem navLinkStyle admin'}
                    >
                        <FontAwesomeIcon icon={faCogs} />
                        &nbsp; {kedo.t('Admin settings')}
                        <FontAwesomeIcon
                            icon={
                                this.state.displayAdminSettings
                                    ? faChevronCircleUp
                                    : faChevronCircleDown
                            }
                            className={'dropArrow float-right'}
                        />
                    </div>
                ) : null}
                {this.state.displayAdminSettings ? (
                    <ul onClick={() => window.scrollTo(0, 0)}>
                        {AdminMenuItems.map(
                            (item) =>
                                kedo.hasPermissionFor(item.permission) && (
                                    <li
                                        key={item.id}
                                        onClick={this.props.close}
                                    >
                                        <NavLink
                                            to={item.path}
                                            className={
                                                'MainMenuLink navLinkStyle'
                                            }
                                            activeClassName="selectedLink"
                                        >
                                            {item.icon && (
                                                <FontAwesomeIcon
                                                    icon={item.icon}
                                                />
                                            )}{' '}
                                            {kedo.t(item.label)}
                                        </NavLink>
                                    </li>
                                )
                        )}
                        {kedo.isAdmin() ? (
                            <li key={'messagequeue'}>
                                <NavLink
                                    to={'/messagequeue'}
                                    className={'MainMenuLink navLinkStyle'}
                                    activeClassName="selectedLink"
                                >
                                    {kedo.t('admin:message_queue')}
                                </NavLink>
                            </li>
                        ) : null}
                    </ul>
                ) : null}
            </nav>
        )
    }
}

export default AdminMainMenu
